import * as BABYLON from "@babylonjs/core/Legacy/legacy";
import { GameScene } from "./scene.js";
import { config } from "./config";

export class Ground {
	private mesh: BABYLON.Mesh;

	constructor(gameScene: GameScene) {
		let scene = gameScene.bbScene;
		// 分割成 16x16 的大小
		var grid = {
			h: 16,
			w: 16,
		};
		let len = config.waterLen;

		// 大小是 2Len x 2Len 的 ground
		const mesh = BABYLON.MeshBuilder.CreateTiledGround("Tiled Ground", {
			xmin: -len,
			zmin: -len,
			xmax: len,
			zmax: len,
			subdivisions: grid,
		});

		var shaderMaterial = new BABYLON.ShaderMaterial(
			"water",
			scene,
			"./src/shader/water", // 指定 shader 的目录
			{
				uniforms: [
					"world",
					"worldView",
					"worldViewProjection",
					"view",
					"projection",
					"time",
					"direction",
					"viewProjection",
					"vFogInfos",
					"vFogColor",
				],
			},
		);
		let tex = gameScene
			.GetAsset()
			.loadTexture("./assets/aerial_grass_rock_diff_512.jpg");
		shaderMaterial.setTexture("textureSampler", tex);
		shaderMaterial.onBind = function (mesh) {
			var effect = shaderMaterial.getEffect();
			effect.setFloat4(
				"vFogInfos",
				scene.fogMode,
				scene.fogStart,
				scene.fogEnd,
				scene.fogDensity,
			);
			effect.setColor3("vFogColor", scene.fogColor);
		};
		mesh.material = shaderMaterial;
		this.mesh = mesh;

		// 向 scene 注册 update callback
		const startTime = new Date();
		gameScene.addUpdateCallback(function () {
			const endTime = new Date();
			const timeDiff = (endTime.getTime() - startTime.getTime()) / 1000; // in s
			shaderMaterial.setFloat("time", timeDiff);
		});
	}

	update(playerPos: BABYLON.Vector2) {
		/*
        xxxx
         xxxx
          xxxx
        ground 根据人物的位置按 1/4 长度移动
        */
		let self = this;
		let unit = config.waterLen / 2;
		let x = Math.ceil(playerPos.x / unit) * unit;
		let y = Math.ceil(playerPos.y / unit) * unit;
		self.mesh.position.x = x;
		self.mesh.position.z = y;
	}
}
